import Evented from './Evented';
export class Metrics extends Evented {
    constructor() {
        super(...arguments);
        this.backends = new Map();
    }
    registerHost(host, options) {
        const backendInfo = `${options.ssl ? 'secure:' : 'insecure'}${options.host}`;
        host.on('up', () => this.emit('up', backendInfo));
        host.on('down', () => this.emit('down', backendInfo));
        host.on('heartbeat', () => this.emit('heartbeat', backendInfo));
        this.backends.set(backendInfo, host);
    }
    generate() {
        const out = {};
        this.backends.forEach((host, key) => {
            out[key] = host.metrics;
        });
        return out;
    }
}
//# sourceMappingURL=Metrics.js.map